<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=''"/>
    <Notification v-if="$store.state.notificationDetails.show" :messages="messages" @close="handleClose()"/>
    <div id="app">
        <div id="header">
            <AppHeader :categories="categories"/>
        </div>
        <div id="container">
            <router-view/>
        </div>
        <div id="footer">
            <AppFooter :categories="categories" :contactInfos="contactInfos"/>
        </div>
    </div>
</template>
<script>
    import AppHeader from './components/AppHeader'
    import AppFooter from './components/AppFooter'
    import Notification from './components/Notification'
    import axios from 'axios'
    import Alert from "./components/Alert"
    import Pusher from 'pusher-js';
    export default {
        name: 'App',
        components: {
            AppHeader,
            AppFooter,
            Notification,
            Alert
        },
        data() {
            return {
                messages: [],
                unreadMessagesCount: 0,
                alertContent: null,
                loadingMood: false,
                categories: null,
                contactInfos: null,
                channels:[],
            }
        },
        methods: {
            handleClose() {
                this.messages = [];
                this.unreadMessagesCount = 0;
                this.$store.state.notificationDetails.show = false;
                this.$store.state.notificationDetails.unreadMessagesCount = 0;
            },
            startListening() {
                if (localStorage.getItem('unique_id') != null) {
                    let pusher = new Pusher('cbbfe2a7885f291a7196', {
                        cluster: 'eu'
                    });
                    const unique_id = localStorage.getItem('unique_id');
                    let channel = pusher.subscribe(`messages.${unique_id}`);
                    channel.bind('new-message', (data) => {
                        if (data.message.side !== 'user') {
                            if (this.$route.name !== 'ConversationWithExperts') {
                                this.unreadMessagesCount += 1;
                                this.$store.state.notificationDetails.unreadMessagesCount = this.unreadMessagesCount;
                                this.messages.unshift(data.message);
                            };
                        }
                    });
                    this.groupsListening();
                }
            },
            async groupsListening() {
                try {
                    if (!this.$store.state.groupsIds) {
                        let response = await axios.get('api/userDashboard/groupsIds', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                        this.$store.state.groupsIds = response.data.results;
                    }
                    if (this.$store.state.groupsIds) {
                        const groupsIds = this.$store.state.groupsIds;
                        groupsIds.forEach(this.createChannel);
                        this.startGroupsListening();
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            createChannel(item) {
                this.channels.push('publicMessages.' + item)
            },
            startGroupsListening(){
                let pusher = new Pusher('cbbfe2a7885f291a7196', {
                    cluster: 'eu'
                });
                //Pusher.logToConsole = true;
                for (let key in this.channels) {
                    let chl = pusher.subscribe(this.channels[key]);
                    chl.bind('new-message', (data) => {
                            if (this.$route.params.mode !== 'group-messaging') {
                                this.unreadMessagesCount += 1;
                                this.$store.state.notificationDetails.unreadMessagesCount = this.unreadMessagesCount;
                                this.messages.unshift(data.message);
                            }
                    });
                }
            },
            async getHeaderCategoriesInfos() {
                try {
                    this.loadingMood = false;
                    let response = await axios.get('api/getMainCategories/Header');
                    this.loadingMood = false;
                    this.categories = response.data.results;
                } catch (error) {
                    console.log(error)
                }
            },
            async getContactInfosInfos() {
                try {
                    this.loadingMood = false;
                    let response = await axios.get('api/getContactInfos');
                    this.loadingMood = false;
                    this.headerCategories = response.data.headerCategories;
                    this.contactInfos = response.data.results;
                    if (this.contactInfos.telegram) {
                        this.$store.state.socialMediaLinks.telegram = this.contactInfos.telegram;
                    }
                    if (this.contactInfos.instagram) {
                        this.$store.state.socialMediaLinks.instagram = this.contactInfos.instagram;
                    }
                } catch (error) {
                    console.log(error)
                }
            },
        },
        created() {
            this.startListening();
            this.getHeaderCategoriesInfos();
            this.getContactInfosInfos();
        }
    }
</script>
<style lang="scss">
    body {
        overflow-x: hidden !important;
        background-color: #162336;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        direction: rtl;
    }

    @font-face {
        font-family: "IRANSans";
        src: url(./fonts/FontsFree-farsi-degits.woff) format("truetype");
    }

    #app {
        font-family: "IRANSans";
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;

        height: 100vh;
        display: flex;
        flex-direction: column;
        display: -ms-flexbox;
        -ms-flex-direction: column;
    }

    .space {
        height: 10px;
        width: 100%;
        background-color: #162336;
    }

    .btn-hover:hover {
        background-color: #fe7063 !important;
        color: white !important;
    }

    a {
        cursor: pointer;
        color: #162336;
    }

    a:hover {
        color: #fe7063;
    }

    button {
        cursor: pointer;
        border: none !important;
    }

    .rtl-direction {
        direction: rtl;
    }

    #container {
        flex: 1;
        -ms-flex: 1 1 auto;
    }

    .box-container {
        width: 100%;
        height: auto;
        background-color: white;
    }

    .container-size-fixer {
        max-width: 1150px !important;
        width: 100%;
        height: auto;
    }

    input:focus {
        box-shadow: none !important;
    }

    button:focus {
        border: none !important;
        outline: 0;
    }

    select:focus {
        border: none !important;
        outline: 0;
    }

    button {
        border: none;
    }

    textarea:focus {
        box-shadow: none !important;
    }

    textarea.form-control {
        min-height: 115px;
    }

    /*ul{*/
    /*padding: 0!important;*/
    /*}*/
</style>
